import { types } from 'mobx-state-tree'

const TaskGlobalTiming = types.model('TaskGlobalTiming', {
  id: types.identifierNumber,
  time: types.string
})

export type ITaskGlobalTiming = typeof TaskGlobalTiming.Type
export default TaskGlobalTiming